export default __webpack_public_path__ + "static/media/offlineUsers.c326a791.svg";